import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from 'util/api';

// Resolve a linked entity across server pages rather than assuming it is on page one.
export default function useBillingNotificationEntity(kind) {
  const location = useLocation();
  const targetGuid = new URLSearchParams(location.search).get(
    'notificationEntity'
  );
  const [result, setResult] = useState({
    entity: null,
    error: null,
    loading: false
  });
  useEffect(() => {
    let disposed = false;
    if (!targetGuid) {
      setResult({ entity: null, error: null, loading: false });
      return;
    }
    setResult({ entity: null, error: null, loading: true });
    const load = async () => {
      try {
        for (let skip = 0; !disposed; skip += 100) {
          const response = await (kind === 'sponsorship'
            ? api.OrganizationBilling.sponsorships(skip, 100)
            : api.OrganizationBilling.hostedAccounts(skip, 100));
          const page = response?.Data ?? response;
          const rows = page?.Objects ?? [];
          const entity = rows.find(
            item => (item.GUID ?? item.guid) === targetGuid
          );
          if (disposed) return;
          if (entity) {
            setResult({ entity, error: null, loading: false });
            return;
          }
          if (rows.length < 100 || page.EndOfResults) break;
        }
        if (!disposed)
          setResult({
            entity: null,
            error: 'The notification target is no longer available.',
            loading: false
          });
      } catch {
        if (!disposed)
          setResult({
            entity: null,
            error: 'Unable to load the notification target. Refresh to retry.',
            loading: false
          });
      }
    };
    load();
    return () => {
      disposed = true;
    };
  }, [kind, targetGuid]);
  return { ...result, targetGuid };
}
